/* =============================================================
 * import
 * ========================================================== */
import {eventObserver} from "../modules/eventObserver";
import {gsap} from "gsap/gsap-core";
import {CustomEase} from "gsap/CustomEase";
import {mediaQuery} from "../modules/common";
import * as Common from "../modules/common";
import {modalImages} from "../modules/modal";

gsap.registerPlugin(CustomEase);
CustomEase.create("syu", ".645, .045, .355, 1");


/* =============================================================
 * export function
 * ========================================================== */
export function before() {
  const $body = document.body;
  $body.classList.remove('top_page');
  $body.classList.add('sub_page');
  Common.pickupBnrControl('hyde'); // バナー非表示化
}


export function after(data) {  // eslint-disable-line @typescript-eslint/no-unused-vars
  const listeners = [];
  // mouseStoker();

  const btn = document.querySelectorAll('.totop');
  if (btn.length > 0) {
    btn.forEach(elem => {
      elem.addEventListener('click', toTop, false);
      listeners.push([elem, 'click', toTop, false]);
    });
  }

  const searchBtnOpen = document.querySelector('#searchBtn');
  if (searchBtnOpen) {
    searchBtnOpen.addEventListener('click', searchOpen, false);
    listeners.push([searchBtnOpen, 'click', searchOpen, false]);
  }

  if (mediaQuery() !== 'sp') {
    const searchBtnClose = document.querySelector('#searchBtnClose');
    if (searchBtnClose != null) {
      searchBtnClose.addEventListener('click', searchClose, false);
      listeners.push([searchBtnClose, 'click', searchClose, false]);
    }
    imgSwitcher();
  }

  Common.txtUp();
  Common.acodion();
  Common.slideDownBtn();
  Common.slideDownBtnHover();
  Common.tabExchanger();
  Common.tableScrollHint();
  Common.pickupBnrControl('show', data); // バナー表示
  modalImages();

  eventObserver.observeEvents(listeners);
}


/* =============================================================
 * function
 * ========================================================== */

export function toTop() {
  gsap.to(window, {duration: 1, scrollTo: 0});
}


let currentAnimationBtn;
let currentAnimationArea;
let currentAnimationClose;
function searchOpen() {
  const searchBtn = document.querySelector('#searchBtn');
  const searchArea = document.querySelector('#searchArea');
  const searchClose = document.querySelector('#searchBtnClose');
  const duration = .5;

  if (currentAnimationBtn) currentAnimationBtn.kill();
  if (currentAnimationArea) currentAnimationArea.kill();
  if (currentAnimationClose) currentAnimationClose.kill();

  currentAnimationBtn = gsap.to(searchBtn, {
    autoAlpha: 0,
    duration: duration,
  });
  currentAnimationArea = gsap.to(searchArea, {
    autoAlpha: 1,
    duration: duration,
  });
  currentAnimationClose = gsap.to(searchClose, {
    autoAlpha: 1,
    duration: duration,
  });
}


function searchClose() {
  const searchBtn = document.querySelector('#searchBtn');
  const searchArea = document.querySelector('#searchArea');
  const searchClose = document.querySelector('#searchBtnClose');
  const duration = .5;

  if (currentAnimationBtn) currentAnimationBtn.kill();
  if (currentAnimationArea) currentAnimationArea.kill();
  if (currentAnimationClose) currentAnimationClose.kill();

  currentAnimationBtn = gsap.to(searchBtn, {
    autoAlpha: 1,
    duration: duration,
  });
  currentAnimationArea = gsap.to(searchArea, {
    autoAlpha: 0,
    duration: duration,
  });
  currentAnimationClose = gsap.to(searchClose, {
    autoAlpha: 0,
    duration: duration,
  });
}


/* =============================================================
 * footerOfferLinkEnter
 * ========================================================== */
export function footerOfferLinkEnter(e) {

  const elm = e.target;
  const elmParent = elm.parentNode;
  const elmNext = elm.nextElementSibling;

  let insetVal;
  if (elmParent.classList.contains('footer_offer_catalog')) {
    insetVal = 'inset(0 50% 0 0)';
  } else {
    insetVal = 'inset(0 0 0 50%)';
  }

  if (elmNext.classList.contains('footer_offer_figure')) {
    elmParent.style.zIndex = "2"; // 横に伸ばす際、下に隠さない
    gsap.fromTo(elmNext, {
      webkitClipPath: insetVal,
      clipPath: insetVal,
    }, {
      webkitClipPath: "inset(0% 0% 0% 0%)",
      clipPath: "inset(0% 0% 0% 0%)",
      ease: 'syu',
      duration: .4,
    });
  }
}


/* =============================================================
 * footerOfferLinkLeave
 * ========================================================== */
export function footerOfferLinkLeave(e) {
  const elm = e.target;
  const elmParent = elm.parentNode;
  const elmNext = elm.nextElementSibling;

  let insetVal;
  if (elmParent.classList.contains('footer_offer_catalog')) {
    insetVal = 'inset(0 50% 0 0)';
  } else {
    insetVal = 'inset(0 0 0 50%)';
  }


  if (elmNext.classList.contains('footer_offer_figure')) {
    elmParent.style.zIndex = "1"; // 元に戻す際、下に隠さない
    gsap.fromTo(elmNext, {
      webkitClipPath: "inset(0% 0% 0% 0%)",
      clipPath: "inset(0% 0% 0% 0%)",
    }, {
      webkitClipPath: insetVal,
      clipPath: insetVal,
      ease: 'syu',
      duration: .4,
      onComplete: () => {
        elmParent.style.zIndex = "0"; // マウスを外した動きが完了した際、初期化
        elmNext.removeAttribute('style');
      },
    });
  }
}


/*
function mouseStoker() {

  if (!isMobile()) {
    const cursor = document.getElementById("cursor");
    const pos = {x: window.innerWidth / 2, y: window.innerHeight / 2}; // カーソル要素の座標（リサイズを考慮し初期位置を画面中央に設定）
    const mouse = {x: pos.x, y: pos.y}; // マウスカーソルの座標
    const speed = 0.5; // 0.01〜1 数値が大きほど早い

    // カーソルの座標を設定する
    const cursorSetX = gsap.quickSetter(cursor, "x", "px");
    const cursorSetY = gsap.quickSetter(cursor, "y", "px");

    const mouseStokerCallback = (pos) => {

      const dt = 1.0 - Math.pow(1.0 - speed, gsap.ticker.deltaRatio());

      pos.x += (mouse.x - pos.x) * dt;
      pos.y += (mouse.y - pos.y) * dt;
      cursorSetX(pos.x);
      cursorSetY(pos.y);

    };

    // マウスカーソル座標を取得する
    document.addEventListener("mousemove", function(event) {
      mouse.x = event.pageX;
      mouse.y = event.pageY;
    });

    // マウスカーソル座標を更新する
    window.addEventListener("resize", function() {
      pos.x = window.innerWidth / 2;
      pos.y = window.innerHeight / 2;
      gsap.ticker.remove(mouseStokerCallback);
      gsap.ticker.add(function() {
        mouseStokerCallback(pos);
      });
    });

    // レンダリングする
    gsap.ticker.add(function() {
      mouseStokerCallback(pos);
    });
  }
}
*/


function imgSwitcher() {
  const listeners = [];
  const btns = document.querySelectorAll(".js-switcherBtn");
  const areas = document.querySelectorAll(".js-switcherImg");
  const onSwitcher = function(e) {
    this.area.forEach(element => {
      element.classList.remove('open');
    });
    // document.getElementById(e.currentTarget.dataset.switcherTarget).classList.add('open');
    document.querySelector(`[data-switcher-id="${e.currentTarget.dataset.switcherTarget}"]`).classList.add('open');
  };

  if (btns.length) {
    btns.forEach(button => {
      const boundOnSwitcher = onSwitcher.bind({ area: areas });

      button.addEventListener('mouseenter', boundOnSwitcher);
      // eventObserver.observeEvents([[button, 'mouseenter', boundOnSwitcher]]);
      listeners.push([button, 'mouseenter', boundOnSwitcher]);
    });
  }

  eventObserver.observeEvents( listeners );
}
